// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

enum ContentShareConstants {
  Modality = '#content',
}

export default ContentShareConstants;
